if (!customElements.get("accordion-wrapper")) {
  class Accordion extends HTMLElement {
    constructor() {
      super();
      this.el = this,
      this.options = this.dataset.options;
      this.items = this.querySelectorAll(".accordion__item");
      this.onlyOneActive = false;

      window.addEventListener('load', () => { 
        this.bindEvents();
      })
    }

    bindEvents() {    
      let t = this;
      this.items.forEach(function (e) {
        let toggle = e.querySelector(".accordion__toggle");
        if(toggle){
          toggle.addEventListener("click", function (o) {
            o.preventDefault();
            t.toggle(e.dataset.item);
          });
          if(e.dataset.open){
            t.toggle(e.dataset.item);
          }
        }

        let toggleNext = e.querySelector(".accordion__toggle-next");
        if(toggleNext) {
          toggleNext.addEventListener("click", function (o) {
            o.preventDefault(),
            t.toggle(parseInt(e.dataset.item) + 1);
          })
        }
      });
    }
        
    toggle(item) {
      let t = this;
      this.items.forEach(function (e) {
        const content = e.querySelector(".accordion__content");
        if(!content) return;
        if(e.dataset.item == item) {
          if(e.classList.contains('is-active')) {
            content.style.maxHeight = null;
          } else {
            content.style.maxHeight = content.scrollHeight + "px";
          }
          e.classList.toggle("is-active");
        } else if(t.onlyOneActive) {
          e.classList.remove("is-active");
          content.style.maxHeight = null;
        }
      });
    }
  }

  customElements.define('accordion-wrapper', Accordion);
}